var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoFeatured = function SvgInfoFeatured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E3F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    fillRule: "evenodd",
    d: "M20 29.333A9.333 9.333 0 0 1 10.667 20 9.333 9.333 0 0 1 20 10.667 9.333 9.333 0 0 1 29.333 20 9.333 9.333 0 0 1 20 29.333ZM8 20c0-6.627 5.373-12 12-12s12 5.373 12 12-5.373 12-12 12S8 26.627 8 20Zm13.333-5.333a1.333 1.333 0 1 0-2.666 0 1.333 1.333 0 0 0 2.666 0ZM18.667 24v-4a1.333 1.333 0 1 1 0-2.666H20c.736 0 1.333.597 1.333 1.333V24a1.333 1.333 0 0 1 0 2.667h-2.666a1.333 1.333 0 0 1 0-2.667Z",
    clipRule: "evenodd"
  })));
};
export default SvgInfoFeatured;